import {
  ExternalBankAccount,
  ExternalBankAccountStatus,
  PayoutRail
} from "@wingspanhq/wingspan-api-sdk";

export const selectorExternalBankAccountRtpReady = (
  externalBankAccount: ExternalBankAccount
) =>
  externalBankAccount.status !== ExternalBankAccountStatus.REMOVED &&
  externalBankAccount.status !== ExternalBankAccountStatus.FAILED &&
  !!externalBankAccount.supportedRails?.includes(PayoutRail.RTP);
